import objectPath from 'object-path'

const getRuleUpdateCheckboxListTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const getRuleUpdateCheckboxListStatus = (status = {}) => {
  let { isDynamic, dynamicName, dynamicKey, dynamicIndex } = status

  return {
    isDynamic,
    dynamicName,
    dynamicKey,
    dynamicIndex,
  }
}

const getRuleUpdateCheckboxListSourceKeys = (
  status = {},
  targetKey = '',
) => {
  let { ruleUiKeys, name, dynamicName, dynamicKey } = status
  let keys = Array.isArray(ruleUiKeys) ? ruleUiKeys : [ruleUiKeys]

  return [...keys, name, dynamicKey, dynamicName]
    .filter((key) => key && key !== targetKey)
    .filter((key, index, list) => list.indexOf(key) === index)
}

const getRuleUpdateCheckboxListValue = (
  designContext = {},
  status = {},
  sourceKey = '',
) => {
  let { jsonForm = {} } = designContext
  let formData = status.formData || jsonForm.formData || {}
  let value = status.valueChange

  if (value === undefined) {
    value = objectPath.get(formData, sourceKey)
  }
  if (value === undefined && sourceKey) {
    value = objectPath.get(formData, `@${sourceKey}`)
  }

  return value && typeof value === 'object' ? value : undefined
}

const setRuleUpdateCheckboxListElementAction = (
  designContext = {},
  targetKey,
  sourceKey,
) => {
  let { elementAction = {}, setElementAction } = designContext
  let updateCheckboxList =
    objectPath.get(elementAction, ['updateCheckboxList']) || []

  if (!Array.isArray(updateCheckboxList)) {
    updateCheckboxList = []
  }
  if (!updateCheckboxList.includes(targetKey)) {
    updateCheckboxList.push(targetKey)
  }

  objectPath.set(elementAction, ['updateCheckboxList'], updateCheckboxList)
  objectPath.set(
    elementAction,
    ['actionUpdateCheckbox', targetKey],
    sourceKey || targetKey,
  )
  if (setElementAction) setElementAction(elementAction)
}

const setRuleUpdateCheckboxListUiChanged = (
  designContext = {},
  action = {},
  status = {},
  targetKey,
  sourceKey,
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext
  let updateStatus = getRuleUpdateCheckboxListStatus(status)
  let selectList = getRuleUpdateCheckboxListValue(
    designContext,
    status,
    sourceKey,
  )

  objectPath.set(isUiChanged, targetKey, {
    isRender: true,
    updateCheckboxList: action,
    ...updateStatus,
  })

  if (selectList !== undefined && sourceKey) {
    objectPath.set(isUiChanged, `${sourceKey}.selectList`, selectList)
  }

  if (setIsUiChanged) setIsUiChanged(isUiChanged)
}

export const onRuleUpdateCheckboxList = (
  designContext = {},
  action = {},
  status = {},
  target = '',
) => {
  let targetKey = getRuleUpdateCheckboxListTarget(action, target)
  if (!targetKey) return undefined

  let sourceKey =
    getRuleUpdateCheckboxListSourceKeys(status, targetKey)[0] || targetKey

  setRuleUpdateCheckboxListElementAction(
    designContext,
    targetKey,
    sourceKey,
  )
  setRuleUpdateCheckboxListUiChanged(
    designContext,
    action,
    status,
    targetKey,
    sourceKey,
  )

  return {
    key: targetKey,
    sourceKey,
    ...getRuleUpdateCheckboxListStatus(status),
  }
}
